var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32610",
    "data-name": "Group 32610",
    transform: "translate(-740 -430)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    rx: 20,
    ry: 20,
    transform: "translate(740 430)",
    fill: "#ffdada"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34209",
    "data-name": "Group 34209",
    transform: "translate(-10255 -6256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34209-2",
    "data-name": "Group 34209",
    transform: "translate(11008 6698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M948.443,347.664c-3.514,0-6.515.532-6.515,2.659S944.911,353,948.443,353c3.514,0,6.514-.527,6.514-2.655S951.976,347.664,948.443,347.664Z",
    transform: "translate(-941.928 -336.278)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M948.243,345.6a4.16,4.16,0,1,0-.031,0Z",
    transform: "translate(-941.728 -337.25)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13952",
    "data-name": "Rectangle 13952",
    width: 24,
    height: 24,
    transform: "translate(11003 6695)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34211",
    "data-name": "Group 34211",
    transform: "translate(11021.166 6696.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34171",
    "data-name": "Group 34171",
    transform: "translate(0.028 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34167",
    "data-name": "Group 34167",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40314",
    "data-name": "Path 40314",
    d: "M234.266,173c-.387,0-.688.207-.688.575,0,1.122.132,2.735.132,3.857,0,.292.255.415.556.415.226,0,.547-.123.547-.415,0-1.122.132-2.735.132-3.857A.606.606,0,0,0,234.266,173Z",
    transform: "translate(-233.578 -173.005)",
    fill: "#fc5a5a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34172",
    "data-name": "Group 34172",
    transform: "translate(0 5.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34169",
    "data-name": "Group 34169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40315",
    "data-name": "Path 40315",
    d: "M233.377,353.306a.726.726,0,0,0,0,1.452.726.726,0,0,0,0-1.452Z",
    transform: "translate(-232.651 -353.306)",
    fill: "#fc5a5a"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.0f665ed1.svg";
export { ForwardRef as ReactComponent };